import {
    DashboardExpiringSamplesColumnEnum,
    dashboardExpiringSamplesTableColumnText,
    DashboardOrdersColumnEnum,
    dashboardOrderTableColumnText,
} from '../enums';
import { DashboardResultsColumnEnum, dashboardResultsTableColumnText } from '../enums/dashboard-results-column.enum';
import { DashboardTableColumn } from '../interfaces';

export function initializeDashboardOrderTableColumns(): DashboardTableColumn<DashboardOrdersColumnEnum>[] {
    return [
        {
            field: DashboardOrdersColumnEnum.ORDER_NAME,
            name: dashboardOrderTableColumnText[DashboardOrdersColumnEnum.ORDER_NAME],
            centered: false,
            width: '17.5%',
            minWidth: '240px',
        },
        {
            field: DashboardOrdersColumnEnum.STATUS,
            name: dashboardOrderTableColumnText[DashboardOrdersColumnEnum.STATUS],
            centered: true,
            width: '12.5%',
            minWidth: '180px',
        },
        {
            field: DashboardOrdersColumnEnum.REQUESTER,
            name: dashboardOrderTableColumnText[DashboardOrdersColumnEnum.REQUESTER],
            centered: false,
            width: '15%',
            minWidth: '140px',
        },
        {
            field: DashboardOrdersColumnEnum.NUMBER_OF_REACTIONS,
            name: dashboardOrderTableColumnText[DashboardOrdersColumnEnum.NUMBER_OF_REACTIONS],
            centered: true,
            width: '10%',
            minWidth: '140px',
        },
        {
            field: DashboardOrdersColumnEnum.DATE_CREATED,
            name: dashboardOrderTableColumnText[DashboardOrdersColumnEnum.DATE_CREATED],
            centered: true,
            width: '10%',
            minWidth: '185px',
        },
    ];
}

export function initializeDashboardExpiringSamplesTableColumns(): DashboardTableColumn<DashboardExpiringSamplesColumnEnum>[] {
    return [
        {
            field: DashboardExpiringSamplesColumnEnum.SAMPLE,
            name: dashboardExpiringSamplesTableColumnText[DashboardExpiringSamplesColumnEnum.SAMPLE],
            centered: false,
            width: '17.5%',
            minWidth: '240px',
        },
        {
            field: DashboardExpiringSamplesColumnEnum.LAST_USED,
            name: dashboardExpiringSamplesTableColumnText[DashboardExpiringSamplesColumnEnum.LAST_USED],
            centered: true,
            width: '16.5%',
            minWidth: '120px',
        },
        {
            field: DashboardExpiringSamplesColumnEnum.STORAGE_DATE_END,
            name: dashboardExpiringSamplesTableColumnText[DashboardExpiringSamplesColumnEnum.STORAGE_DATE_END],
            centered: true,
            width: '16.5%',
            minWidth: '150px',
        },
    ];
}

export function initializeDashboardOrderResultsTableColumns(): DashboardTableColumn<DashboardResultsColumnEnum>[] {
    return [
        {
            field: DashboardResultsColumnEnum.ORDER_NAME,
            name: dashboardResultsTableColumnText[DashboardResultsColumnEnum.ORDER_NAME],
            centered: false,
            width: '17.5%',
            minWidth: '240px',
        },
        {
            field: DashboardResultsColumnEnum.NUMBER_OF_REACTIONS,
            name: dashboardResultsTableColumnText[DashboardResultsColumnEnum.NUMBER_OF_REACTIONS],
            centered: true,
            width: '16.5%',
            minWidth: '120px',
        },
        {
            field: DashboardResultsColumnEnum.RESULTED,
            name: dashboardResultsTableColumnText[DashboardResultsColumnEnum.RESULTED],
            centered: true,
            width: '16.5%',
            minWidth: '185px',
        },
        {
            field: DashboardResultsColumnEnum.DOWNLOAD,
            name: dashboardResultsTableColumnText[DashboardResultsColumnEnum.DOWNLOAD],
            centered: true,
            width: '16.5%',
            minWidth: '150px',
        },
    ];
}
